import { Action } from '@/core/util/permission-action';

export const ACTION_PERMISSION_MAP: Record<string, Action> = {
    edit:    'EDIT'    as Action,
    delete:  'DELETE'  as Action,
    create:  'CREATE'  as Action,
    view:    'VIEW'    as Action,
    export:  'EXPORT'  as Action,
    import:  'IMPORT'  as Action,
    approve: 'APPROVE' as Action,
    reject:  'REJECT'  as Action,
};
